module.exports = __webpack_public_path__ + "static/media/gun.52a826dd.JPG";